import React from 'react';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import SettingsBackArrow from '@/components/userSettings/SettingsBackArrow';
import { useUserCloudQuery } from '@/hooks/onboarding/useReferralQuery';
import Account from '@/components/account/desktop/Account';
import Seo from '@/components/shared/Seo';
export default function AccountSettingsPage() {
  const {
    data: userCloudData
  } = useUserCloudQuery();
  return <>
      <Seo title='Account Settings' data-sentry-element="Seo" data-sentry-source-file="index.tsx" />
      <FullScreenGuard data-sentry-element="FullScreenGuard" data-sentry-source-file="index.tsx">
        <>
          <div className='w-full my-4 pl-4'>
            <SettingsBackArrow data-sentry-element="SettingsBackArrow" data-sentry-source-file="index.tsx" />
          </div>
          <div className='px-4'>
            <Account userInfo={userCloudData} data-sentry-element="Account" data-sentry-source-file="index.tsx" />
          </div>
        </>
      </FullScreenGuard>
    </>;
}